<template>
  <DxButton icon="comment"
            styling-mode="text"
            @click="openUserSnap"
  />
</template>

<script setup>
import DxButton from 'devextreme-vue/button'

const openUserSnap = () => {
  if (window.UsersnapApi)
    window.UsersnapApi.open()
}
</script>

<style scoped lang="scss">
</style>
